import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; // 支持 GitHub 样式的语法yarn
import 'katex/dist/katex.min.css'; // 导入 KaTeX 的样式
import rehypePrism from 'rehype-prism';  // 支持代码高亮
import remarkMath from 'remark-math'; // 支持数学公式
import rehypeKatex from 'rehype-katex'; // 渲染数学公式
import 'prismjs';
import 'prismjs/themes/prism.css';  // 加载 Prism 代码高亮主题
import 'prismjs/components/prism-javascript.min.js'
import 'prismjs/components/prism-python.min.js'
import 'prismjs/components/prism-css.min.js'
import 'prismjs/components/prism-cshtml.min.js'
import 'prismjs/components/prism-java.min.js'
import 'prismjs/components/prism-c.min.js'
import 'prismjs/components/prism-swift.min.js'

import './render.css'


const renderMarkdown = (content) => {
    // 匹配行内公式 \( ... \)
    const inlineMathRegex = /\\\((.*?)\\\)/g;
    // 匹配段落公式 \[ ... \]，支持跨行匹配
    const blockMathRegex = /\\\[\s*([\s\S]*?)\s*\\\]/g;

    // 替换行内公式为 $...$
    let output = content.replace(inlineMathRegex, (match, p1) => {
        return `$ ${p1} $`;  // 用$包裹行内公式
    });

    // 替换段落公式为 $$...$$
    output = output.replace(blockMathRegex, (match, p1) => {
        return `\n$$\n${p1}\n$$`;  // 用$$包裹段落公式
    });

    return (
        <div>
            <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} // 支持数学公式
                           rehypePlugins={[rehypeKatex, rehypePrism]}
            >
                {output}
            </ReactMarkdown>
        </div>
    );
};

export default renderMarkdown;